import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'warehouse',
    pluginName: 'LOGISTIC',
    entityName: 'WAREHOUSE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    fetchSuccessUseBackendMessage: false,
    fetchFailedUseBackendMessage: false,
    createSuccessUseBackendMessage: true,
    createFailedUseBackendMessage: true,
    deleteSuccessUseBackendMessage: false,
    deleteFailedUseBackendMessage: false,
    loadSuccessUseBackendMessage: false,
    loadFailedUseBackendMessage: false,
    editSuccessUseBackendMessage: false,
    editFailedUseBackendMessage: false,
    bulkDeleteSuccessUseBackendMessage: false,
    bulkDeleteFailedUseBackendMessage: false
});

// Fetch Warehouse action creators
export const fetchWarehouseInit = () => {
    return crudActions.fetchInit();
};
export const fetchWarehouseStart = () => {
    return crudActions.fetchStart();
};
export const fetchWarehouseSuccess = (fetchWarehouseCount, listWarehouseCount) => {
    return crudActions.fetchSuccess(fetchWarehouseCount, listWarehouseCount);
};
export const fetchWarehouseFail = () => {
    return crudActions.fetchFail();
};


export const fetchWarehouse = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchWarehouseStart());
        try {
            let countRes = await rest.post("warehouse/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                let listRes = await rest.post("warehouse/list", filterData);
                if (listRes.data && listRes.data.succeeded) {
                    dispatch(fetchWarehouseSuccess(countRes.data.result.data, listRes.data.result.data));
                    return { data: listRes.data.result.data, count: countRes.data.result.data }
                }
            }
            dispatch(fetchWarehouseFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch warehouses."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: [], count: 0 };
        } catch (error) {
            dispatch(fetchWarehouseFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch warehouses."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [], count: 0 }
        }
    }
};


// Create warehouse  action creators
export const createWarehouseInit = () => {
    return crudActions.createInit();
};
export const createWarehouseStart = () => {
    return crudActions.createStart();
};
export const createWarehouseSuccess = warehouse => {
    return crudActions.createSuccess(warehouse);
};
export const createWarehouseFail = error => {
    return crudActions.createFail(error);
};

export const createWarehouse = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createWarehouseStart());
        try {
            let res = await rest.post('/warehouse/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createWarehouseSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created warehouse.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createWarehouseFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create warehouse."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create warehouse."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createWarehouseFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// load warehouse
export const loadWarehouseInit = () => { return crudActions.loadInit(); };
export const loadWarehouse = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};


// Edit warehouse  action creators
export const editWarehouseInit = () => {
    return crudActions.editInit();
};
export const editWarehouseStart = () => {
    return crudActions.editStart();
};
export const editWarehouseSuccess = warehouse => {
    return crudActions.editSuccess(warehouse);
};
export const editWarehouseFail = error => {
    return crudActions.editFail(error);
};


export const editWarehouse = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editWarehouseStart());
        try {
            let res = await rest.post('/warehouse/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editWarehouseSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated warehouse.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editWarehouseFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit warehouse."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit warehouse."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editWarehouseFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete warehouse 
export const bulkDeleteWarehouseInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteWarehouseStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteWarehouseSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteWarehouseFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteWarehouses = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteWarehouseStart());
        try {
            let res = await rest.post('/warehouse/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteWarehouseSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted warehouses.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteWarehouseFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete warehouse."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete warehouse."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteWarehouseFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// list warehouses
export const listWarehouses = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/warehouse/list', { listAll: true, ...params }, options);
            if (res.data && res.data.succeeded) {
                const warehouses = [];
                for (var warehouse of res.data.result.data) {
                    warehouses.push({
                        value: warehouse.WarehouseID,
                        displayValue: `${warehouse.WarehouseInventoryID} - ${warehouse.Name}`
                    });
                }
                return warehouses;
            }
            else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];

        }
    };
};
